module.exports = __webpack_public_path__ + "static/img/sdfdsfghfdgsdfsa.3266f6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sdfdsfghfdgsdfsa.png
// module id = 7UQR
// module chunks = 2